import React from 'react';
import ContentLoader from 'react-content-loader';
import './Payment.scss';
import { IconIndropPayment, IconDelete } from '../../img';

const PaymentCard = ({
  card,
  otherCard,
  openCloseModal,
  onDelete,
  onPrimary,
  handleDropdown,
  intDropUniq,
  hideShowDrp,
  loading
}) => {
  return (
    <div>
      <div className="invoce-block mt-30">
        <div className="subheader-two-part ">
          <div className="header-sub-title header-subtitle-right ">
            <h4 className="mb-2">Saved Card</h4>
            <div className="subheader-title-right">
              <span className="btn-link" onClick={() => openCloseModal('new')}>Add New Payment Mathod</span>
            </div>
          </div>
        </div>
        <div className="clearfix"></div>
        <div className="card p-15">
          <h4 className="card-saved-intitle">Primary Payment Method</h4>
          <div className="creditcard-list">
            {
              loading == false ?
                card && card.length > 0 ?
                  card.map((c, key) => {
                    return (
                      <div key={key}>
                        <div className="creditcard-item " >
                          <div className="creditcard-left">
                            <h5>Credit Card Number</h5>
                            <span>{c.cnb}</span>
                          </div>
                        </div>
                      </div>
                    );
                  })
                  :
                  <div>
                    <span>No Card Found</span>
                  </div>
                :
                <div className="creditcard-item " >
                  <div className="creditcard-left">
                    <ContentLoader
                      height={40}
                      width={400}
                      speed={2}
                      primaryColor="#eceef4"
                      secondaryColor="#fff"
                    >
                      <rect x="15" y="10" rx="4" ry="4" width="180" height="10" />
                      <rect x="15" y="30" rx="4" ry="4" width="220" height="10" />
                    </ContentLoader>
                  </div>
                </div>
            }
          </div>
        </div>
      </div>

      {
        loading == false &&
        otherCard && otherCard.length > 0 &&
        <div className="invoce-block mt-30">
          <div className="header-sub-title">
            <h4 className="mb-2">Saved Payment Methods</h4>
          </div>
          <div className="clearfix"></div>
          <div className="card p-15">
            <div className="creditcard-list">
              {
                otherCard.map((c, key) => {
                  return (
                    <div key={key} className="mb-15">
                      <div className="creditcard-item" >
                        <div className="creditcard-left">
                          <h5>Credit Card Number</h5>
                          <span>{c.cnb}</span>
                        </div>
                        <div className="creditcard-right" onClick={() => handleDropdown(key)} data-toggle="dropdown">
                          <div className="card-option">
                            <svg xmlns="http://www.w3.org/2000/svg" width="4" height="20" viewBox="0 0 4 20" >
                              <g id="Group_1595" data-name="Group 1595" transform="translate(-630 -228)">
                                <circle id="Ellipse_43" data-name="Ellipse 43" cx="2" cy="2" r="2" transform="translate(630 228)" fill="rgba(131,146,165,0.5)" />
                                <circle id="Ellipse_44" data-name="Ellipse 44" cx="2" cy="2" r="2" transform="translate(630 236)" fill="rgba(131,146,165,0.5)" />
                                <circle id="Ellipse_45" data-name="Ellipse 45" cx="2" cy="2" r="2" transform="translate(630 244)" fill="rgba(131,146,165,0.5)" />
                              </g>
                            </svg>
                          </div>
                          <div className="nf-dropdown dot-dropdown-list card-payment-dropdown" >
                            <ul className={hideShowDrp && intDropUniq == key ? 'nf-dropdownbox' : 'nf-dropdownbox-close nf-dropdownbox'}>
                              <li onClick={() => onPrimary(c.psid)}>
                                <span className="dropdown-pay-icon" >
                                  <img src={IconIndropPayment} alt="" />
                                </span>
                                <h5 alt=""  > Make primary card</h5>
                              </li>
                              <li onClick={() => onDelete(c.psid, key)}>
                                <span className="dropdown-pay-icon dropdoen-icon-delete" >
                                  <img src={IconDelete} alt="" />
                                </span>
                                <h5 >Remove Card</h5>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })
              }
            </div>
          </div>
        </div>
      }
    </div>
  );
};

export default PaymentCard;


// WEBPACK FOOTER //
// ./src/components/Payment/PaymentCard.js